import {JsonProperty} from '@hyperloris/tyson';
import {SyncMetadata} from "./sync-metadata";

export class TableRecordResult<T = any> {

  @JsonProperty()
  success: boolean = false;

  @JsonProperty()
  message: string = '';

  @JsonProperty()
  total: number = 0;

  @JsonProperty()
  records: T[];

  @JsonProperty()
  syncMetadata?: SyncMetadata

  wsViewId?: string;
  requestId?: string;
}

